import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { SupplierContactModel } from '../../../../../../core/models/supplier-contact.model';
import { CrudModeEnum } from '../../../../../../core/base/enum/crud-mode.enum';
import { Observable, Subscription } from 'rxjs';
import { ContactTypeModel } from '../../../../../../core/models/contact-type.model';
import icClose from '@iconify/icons-ic/twotone-close';
import { ContactTypeService } from '../../../../settings/contact-type/contact-type.service';
import { SupplierService } from '../../supplier.service';
import { ActivatedRoute, Router } from '@angular/router';
import { setErrorsMessages } from '../../../../../../core/helpers/form.error.helper';
import { ErrorApi } from '../../../../../../core/models/api/error-api';
import { SupplierContactService } from '../../supplier-contact.service';
import { Typology } from '../../../../../../core/enums/typology.enum';
import { SnackbarService } from '../../../../../../core/services/snackbar.service';
import { ResponseTypeEnum } from '../../../../../../core/base/enum/response-type.enum';
import { FormModalBaseComponent } from '../../../../../../core/base/components/form-modal-base/form-modal-base.component';
import { EstablishmentModel } from '../../../../../../core/models/establishment.model';
import { map } from 'rxjs/operators';
import { EstablishmentService } from '../../../establishment/establishment.service';
import { UserProfileService } from '../../../user-profile/user-profile.service';
import { UserProfileModel } from '../../../../../../core/models/user-profile.model';
import { AffectationModel } from '../../../../../../core/models/affectation.model';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { SupplierContactDeleteConfirmationModalComponent } from '../supplier-contact-delete-confirmation-modal/supplier-contact-delete-confirmation-modal.component';

@Component({
  selector: 'vex-supplier-contact-create-update',
  templateUrl: './supplier-contact-create-update-delete.component.html',
  styleUrls: ['./supplier-contact-create-update-delete.component.scss'],
})
export class SupplierContactCreateUpdateDeleteComponent
  extends FormModalBaseComponent<SupplierContactModel>
  implements OnInit, OnDestroy
{
  protected subscription = new Subscription();

  icClose = icClose;

  form: UntypedFormGroup;
  formNumbers: UntypedFormGroup;
  defaults: SupplierContactModel;
  isQuote = false;
  contactTypes: ContactTypeModel[] = [];
  supplierId: string;
  establishmentId: string;

  importDefaults: any;
  canCreateMode = false;
  canUpdateMode = false;
  canDeleteMode = false;
  canReadMode = false;
  canImportMode = false;

  successCreateMessage: string;
  successUpdateMessage: string;
  successDeleteMessage: string;
  errorCreateMessage: string;
  errorUpdateMessage: string;
  errorDeleteMessage: string;

  establishments$: Observable<any[]>; // Liste complète des établissements
  responsableFilters: any = {};
  selectedAffectations: AffectationModel[] = [];
  filteredEstablishments: { [key: number]: EstablishmentModel[] } = {};
  filteredResponsables: { [key: number]: UserProfileModel[] } = {};
  isCheckedBoxSelectAllEstablishments: boolean;
  loadingEstablishments = false;
  fromEstablishmentDetails = false;
  contactTypeOnly = false;
  unitaryDeletionMode = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data,
    public dialogRef: MatDialogRef<FormModalBaseComponent<SupplierContactModel>>,
    private contactTypeService: ContactTypeService,
    private supplierService: SupplierService,
    public activatedRoute: ActivatedRoute,
    private router: Router,
    public snackbarService: SnackbarService,
    public service: SupplierContactService,
    private establishmentService: EstablishmentService,
    public userProfileService: UserProfileService,
    public fb: UntypedFormBuilder,
    private dialog: MatDialog,
  ) {
    super(data, dialogRef, service);
    if (this.data) {
      this.defaults = this.data?.defaults ?? ({} as SupplierContactModel);
      this.mode = this.data.mode;
      this.isQuote = this.data.isQuote ?? false;
      this.fromEstablishmentDetails = this.data.fromEstablishmentDetails ?? false;
      this.contactTypeOnly = this.data.contactTypeOnly ?? false;
      this.unitaryDeletionMode = this.data.unitaryDeletionMode ?? false;
    }
  }

  ngOnInit() {
    super.ngOnInit();

    if (this.fromEstablishmentDetails) {
      delete this.defaults.affectations;
      this.selectedAffectations = [];
    }

    // if (this.data?.defaults?.affectations && this.data.defaults.affectations.length > 0) {
    //     this.selectedAffectations = this.data.defaults.affectations.map(affectation => ({
    //         establishment: affectation.establishment ? {...affectation.establishment} : {_id: '', label: ''},
    //         responsable: affectation.responsable ? {...affectation.responsable} : {_id: '', fullName: ''}
    //     }));
    // } else {
    //     this.selectedAffectations = [];
    // }

    if (
      !this.fromEstablishmentDetails &&
      this.data?.defaults?.affectations &&
      this.data.defaults.affectations.length > 0
    ) {
      this.selectedAffectations = this.data.defaults.affectations.map(affectation => ({
        establishment: affectation.establishment ? { ...affectation.establishment } : { _id: '', label: '' },
        responsable: affectation.responsable ? { ...affectation.responsable } : { _id: '', fullName: '' },
      }));

      // Charger immédiatement les responsables pour chaque établissement sélectionné
      this.selectedAffectations.forEach((affectation, index) => {
        if (affectation.establishment._id) {
          //    this.loadResponsablesForEstablishment(affectation.establishment._id, index);
        }
      });
    }

    if (!this.fromEstablishmentDetails) {
      // Charger la liste des établissements dès l'initialisation
      this.establishmentService
        .findAllAsSelect(true, null, 'asc', '', { allEstablishmentsForced: true })
        .pipe(map(x => x.data))
        .subscribe(establishments => {
          this.selectedAffectations.forEach((_, index) => {
            this.filteredEstablishments[index] = establishments;
          });
        });
    }

    this.canCreateMode = this.isCreateMode();
    this.canUpdateMode = this.isUpdateMode();
    this.canDeleteMode = this.isDeleteMode();
    this.canReadMode = this.isReadMode();
    this.canImportMode = this.isImportMode();

    this.supplierId = this.data.id;
    this.establishmentId = this.data.establishmentId;
    this.contactTypeService.findAll().subscribe(x => {
      this.contactTypes = x.data.filter(x => x.typology === Typology.supplier);

      if (this.isUpdateMode() || (this.isCreateMode() && this.defaults?.contactTypes?.length > 0)) {
        const a = [];
        if (this.isUpdateMode()) {
          this.isCheckedBoxSelectAllEstablishments = this.unitaryDeletionMode
            ? false
            : this.defaults?.isCheckedBoxSelectAllEstablishments;
          if (this.unitaryDeletionMode) {
            this.form.controls.isCheckedBoxSelectAllEstablishments.setValue(false);
          }
        }
        (this.defaults.contactTypes || []).forEach(x => {
          const ct = this.contactTypes.findIndex(y => y._id === x._id);
          if (ct !== -1) {
            a.push(this.contactTypes[ct]);
          }
        });
        this.form.controls.contactTypes.setValue(a);
      }

      if (this.isQuote) {
        const a = this.contactTypes.filter(x => x.label === 'Devis');
        this.form.controls.contactTypes.setValue(a);
      }
    });

    this.initForm();

    if (!this.fromEstablishmentDetails && this.isCreateMode()) {
      this.form.controls.isCheckedBoxSelectAllEstablishments.setValue(true);
      this.selectAllEstablishments(true);
    }

    if (this.unitaryDeletionMode) {
      this.isCheckedBoxSelectAllEstablishments = false;
      this.form.controls.isCheckedBoxSelectAllEstablishments.setValue(false);
    }

    if (!this.fromEstablishmentDetails) {
      this.form.controls.establishment.valueChanges.subscribe(value => {
        this.responsableFilters.establishment = value._id;
      });
    }
  }

  initForm() {
    this.form = new UntypedFormGroup({
      _id: new UntypedFormControl(this.defaults?._id),
      firstName: new UntypedFormControl(this.defaults?.firstName, [Validators.required]),
      lastName: new UntypedFormControl(this.defaults?.lastName, [Validators.required]),
      // mobileNumber: new FormControl(this.defaults?.mobileNumber, [Validators.required, Validators.maxLength(10)]),
      email: new UntypedFormControl(this.defaults?.email, [Validators.required, Validators.email]),
      contactTypes: new UntypedFormControl(this.defaults?.contactTypes, [Validators.required]),
      affectations: new UntypedFormControl(this.defaults?.affectations),
      isCheckedBoxSelectAllEstablishments: new UntypedFormControl(this.defaults?.isCheckedBoxSelectAllEstablishments),
      phoneNumbers: this.fb.array([]),
    });
  }

  afterCreateItem(result?: any, error?: any) {
    if (result) {
      this.close(true);
    }
  }

  afterImportItem(result?: any, error?: any) {
    if (result) {
      this.close(true);
      super.ngOnInit();
    }
  }

  afterUpdateItem(result?: any, error?: any) {
    if (result) {
      this.close(true);
    }
  }

  close(data?: any): void {
    this.dialogRef.close(data);
  }

  deleteItem() {
    // Si suppression depuis un établissement, pas de vérification d'impact fournisseur
    if (this.establishmentId) {
      this.performDelete();
      return;
    }

    const dialogSub = this.dialog
      .open(SupplierContactDeleteConfirmationModalComponent, {
        data: { supplierId: this.supplierId, contactId: this.defaults?._id },
        width: '600px',
      })
      .afterClosed()
      .subscribe(confirmed => {
        if (confirmed === 'unitary') {
          this.openUnitaryDeletionEdit();
        } else if (confirmed) {
          this.performDelete();
        }
      });
    this.subscription.add(dialogSub);
  }

  private openUnitaryDeletionEdit() {
    const editDialog = this.dialog.open(SupplierContactCreateUpdateDeleteComponent, {
      data: {
        defaults: this.defaults,
        mode: CrudModeEnum.Update,
        id: this.supplierId,
        unitaryDeletionMode: true,
      },
    });
    const sub = editDialog.afterClosed().subscribe(result => {
      if (result) {
        this.close(result);
      }
    });
    this.subscription.add(sub);
  }

  private performDelete() {
    this.loading = true;
    const delete$ = this.establishmentId
      ? this.establishmentService.deleteContact(this.establishmentId, this.defaults?._id)
      : this.supplierService.deleteContact(this.supplierId, this.defaults?._id);
    const sub = delete$.subscribe(
      result => {
        this.close(result);
        this.loading = false;
      },
      error => {
        console.log(error);
        this.snackbarService.danger(error.error.message);
        this.loading = false;
        this.close(false);
      },
    );
    this.subscription.add(sub);
  }

  setErrorsMessages(errors: Array<ErrorApi>) {
    errors?.forEach(error => {
      let err = this.form.controls[error.property].errors;
      if (err === null) {
        err = { messages: [] };
      }
      err.messages.push(error.message);
      this.form.controls[error.property].setErrors(err);
    });
    this.form.markAllAsTouched();
  }

  public beforeCreateItem() {
    if (this.data?.isCreateInContract) {
      this.defaults.isCreateInContract = true;
    }

    if (!this.fromEstablishmentDetails && this.selectedAffectations.length > 0) {
      this.defaults.affectations = this.selectedAffectations;
    }
    if (this.fromEstablishmentDetails) {
      delete this.defaults.affectations;
    }
  }

  createItem() {
    this.loading = true;
    this.defaults = this.form.value;

    this.beforeCreateItem();

    console.log('Creating contact with data:', {
      supplierId: this.supplierId,
      establishmentId: this.establishmentId,
      defaults: this.defaults,
      formValid: this.form.valid,
    });

    if (this.form.valid) {
      const request$ = this.establishmentId
        ? this.establishmentService.createContact(this.establishmentId, this.defaults)
        : this.service.createContactWithConflictHandling(this.supplierId, this.defaults);
      const sub = request$.subscribe(
        res => {
          console.log('DEBUG - Contact creation/replacement response:', res);
          // Toujours retourner true pour déclencher le refresh du parent,
          // même si c'est une réponse de remplacement avec structure différente
          this.close(res?.refreshRequired !== false ? res || true : true);
          this.loading = false;
        },
        err => {
          if (err.cancelled) {
            // L'utilisateur a annulé la création lors de la modale de conflit
            this.loading = false;
            return;
          }
          setErrorsMessages(err?.error?.errors, this.form);
          this.loading = false;
        },
      );
      this.subscription.add(sub);
    } else {
      this.form.markAllAsTouched();
      this.loading = false;
    }
  }

  updateItem() {
    this.loading = true;
    this.defaults = this.form.value;

    this.beforeUpdateItem();
    if (this.form.valid) {
      const update$: Observable<any> = this.establishmentId
        ? this.establishmentService.updateContact(this.establishmentId, this.defaults)
        : this.service.updateContactWithConflictHandling(this.supplierId, this.defaults._id, this.defaults);
      const sub = update$.subscribe(
        result => {
          console.log('DEBUG - Contact update/replacement response:', result);
          // Toujours retourner true pour déclencher le refresh du parent
          this.close(result?.refreshRequired !== false ? result || true : true);
          this.loading = false;
        },
        error => {
          if (error.cancelled) {
            // L'utilisateur a annulé la modification lors de la modale de conflit
            this.loading = false;
            return;
          }
          this.setErrorsMessages(error.error.errors);
          this.loading = false;
        },
      );
      this.subscription.add(sub);
    } else {
      this.form.markAllAsTouched();
      this.loading = false;
    }
  }

  async importItems() {
    const supplier = await this.supplierService.entity;
    this.importDefaults = this.importForm.value;
    this.beforeImportItem();
    if (this.importForm.valid) {
      this.loading = true;
      const sub = this.supplierService.importContact(this.importDefaults, supplier._id).subscribe(
        result => {
          this.afterImportItem(result, null);
          this.setSnackbar(ResponseTypeEnum.Success, CrudModeEnum.Import, result.message);
        },
        error => {
          this.afterImportItem(null, error);
          this.setImportErrorsMessages(error.error.errors);
          this.loading = false;
        },
      );
      this.subscription.add(sub);
    } else {
      this.form.markAllAsTouched();
      this.loading = false;
    }
  }

  public beforeUpdateItem() {
    if (!this.fromEstablishmentDetails) {
      if (this.selectedAffectations.length > 0) {
        this.defaults.affectations = this.selectedAffectations;
      } else {
        this.defaults.affectations = [];
      }
    }
    if (this.fromEstablishmentDetails) {
      delete this.defaults.affectations;
    }
  }

  establishmentAutocompleteChange(state: string, index: number) {
    if (!state) {
      state = '';
    }

    this.establishmentService
      .findAllAsSelect(true, null, 'asc', state, { allEstablishmentsForced: true })
      .pipe(map(x => x.data))
      .subscribe(establishments => {
        const selectedIds = new Set(this.selectedAffectations.map(aff => aff.establishment._id));

        // Exclure les établissements déjà sélectionnés
        this.filteredEstablishments[index] = establishments.filter(est => !selectedIds.has(est._id));
      });
  }

  removeAffectation(index: number) {
    this.selectedAffectations.splice(index, 1);
  }

  // onResponsableSelect(event: any, index: number) {
  //     const selectedName = event.option.value;
  //     const selectResponsable = this.filteredResponsables[index].find(resp => resp.fullName === selectedName);
  //
  //     if (selectResponsable) {
  //         this.selectedAffectations[index].responsable = {
  //             _id: selectResponsable._id,
  //             fullName: selectResponsable.fullName,
  //             email: selectResponsable.email
  //         } as Partial<UserProfileModel>;
  //     }
  // }
  //
  // filterResponsables(search: string, index: number) {
  //     const establishmentId = this.selectedAffectations[index]?.establishment?._id;
  //
  //     if (!establishmentId) {
  //         this.filteredResponsables[index] = [];
  //         return;
  //     }
  //
  //     this.userProfileService
  //         .findAllForAffectation(null, null, null, null, search, { establishment: establishmentId })
  //         .pipe(map(x => x.data))
  //         .subscribe(responsables => {
  //             this.filteredResponsables[index] = responsables;
  //         });
  // }

  selectAllEstablishments(isChecked: boolean) {
    this.isCheckedBoxSelectAllEstablishments = isChecked;

    if (isChecked) {
      this.loadingEstablishments = true;
      this.establishmentService
        .findAllAsSelect(true, null, 'asc', '', { allEstablishmentsForced: true })
        .pipe(map(x => x.data))
        .subscribe(establishments => {
          this.selectedAffectations = [];
          this.filteredResponsables = {};

          this.selectedAffectations = establishments.map((est, index) => {
            //      this.loadResponsablesForEstablishment(est._id, index);
            return {
              establishment: { _id: est._id, label: est.label },
              responsable: { _id: '', fullName: '' },
            };
          });

          this.updateFilteredEstablishments();
          this.loadingEstablishments = false;
        });
    } else {
      this.filteredResponsables = {};
      this.selectedAffectations = [];
    }
  }

  addAffectation() {
    const newAffectation = {
      establishment: { _id: '', label: '' },
      responsable: { _id: '', fullName: '' },
    };

    this.selectedAffectations.push(newAffectation);

    const newIndex = this.selectedAffectations.length - 1;

    // Charger immédiatement la liste des établissements disponibles en excluant ceux déjà sélectionnés
    this.updateFilteredEstablishments();
  }

  updateFilteredEstablishments() {
    const selectedIds = new Set(this.selectedAffectations.map(aff => aff.establishment._id));

    this.establishmentService
      .findAllAsSelect(true, null, 'asc', '', { allEstablishmentsForced: true })
      .pipe(map(x => x.data))
      .subscribe(establishments => {
        this.selectedAffectations.forEach((_, index) => {
          this.filteredEstablishments[index] = establishments.filter(est => !selectedIds.has(est._id));
        });
      });
  }

  onEstablishmentSelect(event: any, index: number) {
    const selectedLabel = event.option.value;
    const selectedId = event.option._element.nativeElement.getAttribute('data-id');

    // Vérifier si l'établissement est déjà sélectionné
    const isDuplicate = this.selectedAffectations.some((aff, i) => aff.establishment._id === selectedId && i !== index);

    if (isDuplicate) {
      this.snackbarService.danger('Cet établissement est déjà sélectionné.');
      return;
    }

    this.selectedAffectations[index].establishment = { _id: selectedId, label: selectedLabel };

    // Mettre à jour les établissements disponibles après la sélection
    this.updateFilteredEstablishments();

    // Charger les responsables pour cet établissement
    //   this.loadResponsablesForEstablishment(selectedId, index);
  }

  // loadResponsablesForEstablishment(establishmentId: string, index: number) {
  //     if (!establishmentId) {
  //         this.filteredResponsables[index] = []; // Réinitialiser si pas d'établissement
  //         return;
  //     }
  //
  //     this.userProfileService
  //         .findAllForAffectation(null, null, null, null, '', { establishment: establishmentId })
  //         .pipe(map(x => x.data))
  //         .subscribe(responsables => {
  //             this.filteredResponsables[index] = responsables; // Mettre à jour la liste
  //         });
  // }

  ensureResponsablesLoaded(index: number) {
    const establishmentId = this.selectedAffectations[index]?.establishment?._id;

    if (establishmentId && (!this.filteredResponsables[index] || this.filteredResponsables[index].length === 0)) {
      //   this.loadResponsablesForEstablishment(establishmentId, index);
    }
  }

  isDeleteMode() {
    return this.mode === CrudModeEnum.Delete;
  }

  isCreateMode() {
    return this.mode === CrudModeEnum.Create;
  }

  isUpdateMode() {
    return this.mode === CrudModeEnum.Update;
  }

  isReadMode() {
    return this.mode === CrudModeEnum.Read;
  }

  isImportMode(): boolean {
    return this.mode === CrudModeEnum.Import;
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
}
